'use es6';

export const PENDING = 'PENDING';
export const SUCCEEDED = 'SUCCEEDED';
export const ERRORED = 'ERRORED';